import React, { FC } from "react"
import { useStore } from "stores/utils/use-store"

import { Form, Input, Modal } from "antd"
import { observer } from "mobx-react"

import { SubmitCancelButtons } from "components"
import { TypeItem } from "domains/managingJson/store/types"

export const EditType: FC<{
  onClose: () => void;
}> = observer(({ onClose }) => {
  const {
    dataStore: {
      managingJsonStore,
      managingJsonStore: { selectedElement: { type } },
    },
  } = useStore()

  const onFinishHandler = async(event: TypeItem & { name: string }) => {
    const dataToBack = {
      oldType: type,
      newType: event.newType,
    }

    managingJsonStore.funcAfterSuccess = async() => {
      onClose()
      await managingJsonStore.getData()
    }
    await managingJsonStore.updateType(dataToBack)
  }

  return (
    <Modal style={{ top: "10px" }} visible title="Edit type" footer={null} onCancel={onClose}>
      <Form onFinish={onFinishHandler}>
        <Form.Item label="Old type" name="oldType" style={{ width: "100%" }} initialValue={type}>
          <Input disabled />
        </Form.Item>
        <Form.Item label="New type" name="newType" style={{ width: "100%" }}>
          <Input />
        </Form.Item>
        <SubmitCancelButtons onClose={onClose} isLoading={managingJsonStore.isLoading} />
      </Form>
    </Modal>
  )
})
